import React, { useEffect, useState } from "react";
import Head from "../../../layout/head/Head";
import Content from "../../../layout/content/Content";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  PreviewAltCard,
  Row,
} from "../../../components/Component";
import { set, useForm } from "react-hook-form";
import { Badge, Form, Label, Spinner } from "reactstrap";
import Required from "../../../myComponents/validate/Required";
import Select from "react-select";
import { decrypt, encrypt } from "../../../utils/Encrypt";
import MyDataTable from "../../../myComponents/DataTable/MyDataTable";
import ConfirmModal from "../../../myComponents/modals/ConfirmModal";
import {
  createChapterAPI,
  getChapterAPI,
  getClassDD,
  getLMSSubjectSpecificChapterAPI,
  getStreamByClassDD,
  getSubjectByClassDD,
  getSubjectByClassLMSDD,
  updateChapterAPI,
} from "../../../api/LMS/master";
import { handleStatusChange, hasPermission } from "../../../utils/myFunctions";
import Status from "../../../myComponents/form/Status";
import MyButton from "../../../myComponents/form/MyButton";
import { toast } from "react-toastify";
import useLogout from "../../../hooks/useLogout";
import { useLocation, useNavigate } from "react-router";

const Chapter = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [mode, setMode] = useState("Add");
  const [isLoading, setIsLoading] = useState(false);
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    setError,
    clearErrors,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      status: null,
      streamList: [],
      mode: "Add",
    },
  });
  const location = useLocation();
  const navigate = useNavigate();
  const enc = JSON.parse(localStorage.getItem("userDetail"));
  const user = decrypt(enc?.data || []);
  const isView = hasPermission(user, location?.pathname, "isView");
  const isUpdate = hasPermission(user, location?.pathname, "isUpdate");
  const isDelete = hasPermission(user, location?.pathname, "isDelete");
  const isCreate = hasPermission(user, location?.pathname, "isCreate");
  const [timer, setTimer] = useState(5); // 5 seconds countdown
  useEffect(() => {
    if (!isView) {
      const interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
      // redirect to home page when the timer reaches 0
      if (timer === 0) {
        navigate(-1);
      }
      // clean up the interval when the component unmounts
      return () => clearInterval(interval);
    } else {
      setIsLoading(false);
    }
  }, [timer]);
  const logout = useLogout();
  const [showModal, setShowModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [data, setData] = useState([]);
  const [classList, setClassList] = useState([]);
  const [subjectList, setSubjectList] = useState([]);
  const [column, setColumn] = useState([
    {
      name: "Class",
      selector: (row) => row?.class_name,
      sortable: true,
    },
    {
      name: "Stream",
      selector: (row) => row?.stream,
      sortable: true,
      wrap: true,
    },
    {
      name: "Subject",
      selector: (row) => row?.subject_name,
      sortable: true,
    },
    // {
    //   name: "Subject Code",
    //   selector: (row) => row?.subject_code,
    //   sortable: true,
    //   wrap: true,
    // },
    {
      name: "Chapter",
      selector: (row) => row?.chapter_name,
      sortable: true,
      wrap: true,
    },
    // {
    //   name: "Order",
    //   selector: (row) => row?.order,
    //   sortable: true,
    // },
    {
      name: "Status",
      selector: (row) => row?.status,
      cell: (row) => (
        <div style={{ cursor: "pointer" }} onClick={() => handleToggleStatus(row)}>
          <Badge color={`${row.status == "active" ? "success" : "danger"}`}>
            {row.status == "active" ? "Active" : "Inactive"}
          </Badge>
        </div>
      ),
      sortable: true,
      wrap: true,
    },
    {
      name: "Action",
      wrap: true,
      cell: (row) => (
        <div>
          {isUpdate && (
            <Button outline color={`warning`} size={`xs`} className={`me-1`} onClick={() => handleEdit(row)}>
              {" "}
              <Icon name="edit" />
            </Button>
          )}
        </div>
      ),
    },
  ]);

  useEffect(() => {
    getChapter();
    if (user?.role == "Subject Specialist") {
      const body = {
        value: user?.class_id,
      };
      handleClassChange(body);
      const body1 = {
        value: user?.stream_id,
      };
      handleStreamChange(body1);
    } else {
      getClass();
    }
  }, []);

  const getChapter = () => {
    const data = {};
    setIsLoading(true);
    getChapterAPI(data)
      .then((res) => {
        const status = res.data.status;
        // const status = decrypt(res.data.status);
        if (status) {
          // const decryptedResponse = decrypt(res.data.data.tableData);
          setData(res.data.data);
          toast.clearWaitingQueue();
          setIsLoading(false);
        } else if (!status) {
          toast.clearWaitingQueue();
          setData([]);
          setIsLoading(false);
        } else if (status === "expired") {
          toast.error(res.data.message);
          logout();
        }
      })
      .catch((err) => {
        console.error(err, "got");
      });
  };
  const getClass = () => {
    const data = {};
    getClassDD(data)
      .then((res) => {
        // decrypt data
        const status = res.data.status;
        // const status = decrypt(res.data.status);
        if (status) {
          // const decryptedResponse = decrypt(res.data.data.tableData);
          setClassList(res.data.data);
          toast.clearWaitingQueue();
        } else if (!status) {
          toast.clearWaitingQueue();
          setClassList([]);
        } else if (status === "expired") {
          toast.error(res.data.message);
          logout();
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const handleToggleStatus = (row) => {
    setSelectedRow(row);
    setShowModal(true);
  };
  // const handleStatusChange = (selectedOption) => {
  //   setValue("status", selectedOption || "");
  //   trigger("status");
  // };
  const handleClassChange = (selectedOption) => {
    setValue("class", selectedOption || "");
    trigger("class");
    if (watch("mode") == "Add") {
      setValue("stream", "");
      setValue("subject", "");
    }
    setSubjectList([]);
    const body = {
      class_id: selectedOption?.value,
    };
    if (selectedOption?.value == "2" || selectedOption?.value == "3") {
      const data = {
        class_id: selectedOption?.value,
      };
      getStreamByClass(data);
    }
    if (selectedOption?.value == "1"||selectedOption?.value=="4") {
      getSubjectByClass(body);
    }
  };
  const getSubjectByClass = (body) => {
    getSubjectByClassLMSDD(body)
      .then((res) => {
        const status = res.data.status;
        if (status) {
          setSubjectList(res.data.data);
        } else if (!status) {
          setSubjectList([]);
        } else if (status === "expired") {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        console.log("Err", err);
      });
  };
  const handleSubjectChange = (selectedOption) => {
    setValue("subject", selectedOption || "");
    trigger("subject");
  };
  const handleEdit = (row) => {
    console.log("row", row);

    window.scrollTo(0, 0);
    setIsOpen(!isOpen);
    setMode("Edit");
    setValue("id", row.chapter_id); // Add this for consistent `formData` structure
    setValue("subject", {
      label: row?.subject_name,
      value: row?.subject_id,
    });
    setValue("mode", "Edit");

    trigger("subject");
    // setValue("subject_code", row?.subject_code);
    setValue("chapter_name", row.chapter_name);
    // setValue("order", row.order);
    setValue("status", {
      label: row.status == "active" ? "Active" : "Inactive",
      value: row.status == "active" ? "active" : "inactive",
    });
    setValue("class", {
      label: row.class_name,
      value: row.class_id,
    });
    if (row?.class_id == 1) {
      const body = {
        class_id: row.class_id,
      };

      getSubjectByClass(body);
    }
    if (row?.class_id == 2 || row?.class_id == 3) {
      const body = {
        value: row?.class_id,
        label: row?.class_name,
      };
      handleClassChange(body);
      const payload = {
        value: row?.stream_id,
        label: row?.stream,
      };

      handleStreamChange(payload);
    }
  };
  const onFormSubmit = (data) => {
    const body = {
      ...(user?.role == "Subject Specialist" ? { class_id: user?.class_id } : { class_id: watch("class")?.value }),
      ...(user?.role == "Subject Specialist"
        ? { subject_id: user?.subject_id }
        : { subject_id: watch("subject")?.value }),
      chapter_name: watch("chapter_name"),
      ...(user?.role == "Subject Specialist" ? { stream_id: user?.stream_id } : { stream_id: watch("stream")?.value }),
      // order: watch("order"),
      status: watch("status")?.value,
      ...(mode == "Edit" && { id: watch("id") }),
    };
    if (mode == "Add") {
      createChapterAPI(body)
        .then((res) => {
          // const status = decrypt(res.data.status);
          const status = res.data.status;
          if (status) {
            toast.success(res.data.message);
            toast.clearWaitingQueue();
            getChapter();
            setIsOpen(false);
            setIsLoading(false);
          } else if (!status) {
            setIsLoading(false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
          } else if (res.data.status == "expired") {
            console.log("response", res.data);
            setIsLoading(false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
            logout();
          }
        })
        .catch((err) => {
          console.log("cat", err);

          setIsLoading(false);
          toast.error(err.message);
        });
    }
    if (mode == "Edit") {
      updateChapterAPI(body)
        .then((res) => {
          // const status = decrypt(res.data.status);
          const status = res.data.status;
          if (status) {
            toast.success(res.data.message);
            toast.clearWaitingQueue();
            getChapter();
            setIsOpen(false);
            setIsLoading(false);
          } else if (!status) {
            setIsLoading(false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
          } else if (res.data.status == "expired") {
            console.log("response", res.data);
            setIsLoading(false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
            logout();
          }
        })
        .catch((err) => {
          console.log("cat", err);

          setIsLoading(false);
          toast.error(err.message);
        });
    }
  };

  const confirmStatusChange = () => {
    const updatedStatus = selectedRow.status === "active" ? "inactive" : "active";
    const formObject = {
      id: selectedRow.chapter_id,
      status: updatedStatus,
    };

    const encryptedData = encrypt(formObject);
    const encryptData = {
      zero: encryptedData,
    };
    updateChapterAPI(formObject)
      .then((res) => {
        // decrypt data
        // const status = decrypt(res.data.status);
        const status = res.data.status;
        if (status) {
          getChapter();

          setShowModal(false);
          toast.success(res.data.message);
          toast.clearWaitingQueue();
        } else if (!status) {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (status === "expired") {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => console.error("Error updating status:", err));
  };
  const handleStreamChange = (selectedOption) => {
    setValue("stream", selectedOption || "");
    trigger("stream");
    // setValue("subject", null);
    const body = {
      class_id: watch("class")?.value,
      stream_id: selectedOption?.value,
    };
    getSubjectByClass(body);
  };
  const getStreamByClass = (data) => {
    getStreamByClassDD(data)
      .then((res) => {
        // decrypt data
        const status = res.data.status;
        // const status = decrypt(res.data.status);
        if (status) {
          // const decryptedResponse = decrypt(res.data.data.tableData);
          toast.success(res.data.message);
          setValue("streamList", res.data.data);
          toast.clearWaitingQueue();
        } else if (!status) {
          toast.warning(res.data.message);
          toast.clearWaitingQueue();
          setValue("streamList", []);
        } else if (status === "expired") {
          toast.error(res.data.message);
          logout();
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };
 
  return (
    <>
      <Head title="Chapter | Master" />
      <Content>
        {!isView ? (
          <div className="p-5" style={{}}>
            <p style={{ color: "crimson", textAlign: "center" }}>{"Unauthorized"}</p>
            <p style={{ textAlign: "center" }}>
              You will be redirected to the home page in <b style={{ color: "crimson" }}>{timer} </b> seconds.
            </p>
          </div>
        ) : (
          <>
            <BlockHead size={`sm`}>
              <BlockBetween>
                <BlockHeadContent>
                  <BlockTitle page tag="h3">
                    {"Chapter"}
                  </BlockTitle>
                </BlockHeadContent>
                {isCreate && (
                  <BlockHeadContent>
                    <div className="">
                      <Button
                        color="primary"
                        outline
                        className={`  me-n1`}
                        onClick={() => {
                          setIsOpen(!isOpen);
                          setMode("Add");
                          reset();
                        }}
                      >
                        {<Icon name={isOpen ? "minus" : "plus"} />}
                      </Button>
                    </div>
                  </BlockHeadContent>
                )}
              </BlockBetween>
            </BlockHead>
            <Block>
              <Row className={`g-gs`}>
                {isOpen && (
                  <PreviewAltCard>
                    <Form onSubmit={handleSubmit(onFormSubmit)}>
                      <Row className={`g-gs`}>
                        {/* Class */}
                        {user?.role == "Subject Specialist" ? null : (
                          <Col md={`2`}>
                            <div className="form-group">
                              <Label className="from-label" htmlFor="class">
                                Class
                                <Required />
                              </Label>
                              <div className="form-control-wrap">
                                <Select
                                  className=""
                                  id="class"
                                  options={classList}
                                  {...register("class", {
                                    required: "Please select class",
                                  })}
                                  onChange={handleClassChange}
                                  value={watch("class")}
                                />
                                {errors.class && (
                                  <span
                                    className="invalid"
                                    style={{
                                      color: "#e85347",
                                      fontSize: "11px",
                                      fontStyle: "italic",
                                    }}
                                  >
                                    {errors?.class?.message}
                                  </span>
                                )}
                              </div>
                            </div>
                          </Col>
                        )}
                        {/* Stream */}
                        {user?.role == "Subject Specialist" ? null : (
                          <>
                            {" "}
                            {(watch("class")?.value == "2" || watch("class")?.value == "3") && (
                              <Col md={`2`}>
                                <div className="form-group">
                                  <Label className="from-label" htmlFor="stream">
                                    Stream
                                    <Required />
                                  </Label>
                                  <div className="form-control-wrap">
                                    <Select
                                      className=""
                                      id="stream"
                                      options={watch("streamList")}
                                      {...register("stream", {
                                        required: "Please select stream",
                                      })}
                                      onChange={handleStreamChange}
                                      value={watch("stream")}
                                    />
                                    {errors?.stream && (
                                      <span
                                        className="invalid"
                                        style={{
                                          color: "#e85347",
                                          fontSize: "11px",
                                          fontStyle: "italic",
                                        }}
                                      >
                                        {errors?.stream?.message}
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </Col>
                            )}
                          </>
                        )}
                        {/* Subject */}
                        {user?.role == "Subject Specialist" ? null : (
                          <Col md={`2`}>
                            <div className="form-group">
                              <Label className="from-label" htmlFor="subject">
                                Subject
                                <Required />
                              </Label>
                              <div className="form-control-wrap">
                                <Select
                                  className=""
                                  id="subject"
                                  options={subjectList}
                                  {...register("subject", {
                                    required: "Please select subject",
                                  })}
                                  onChange={handleSubjectChange}
                                  value={watch("subject")}
                                />
                                {errors.subject && (
                                  <span
                                    className="invalid"
                                    style={{
                                      color: "#e85347",
                                      fontSize: "11px",
                                      fontStyle: "italic",
                                    }}
                                  >
                                    {errors?.subject?.message}
                                  </span>
                                )}
                              </div>
                            </div>
                          </Col>
                        )}
                        {/*Chapter Name */}
                        <Col md="4" sm="3" xxl="6">
                          <div className="form-group">
                            <Label className="form-label" htmlFor="chapter_name">
                              {"Chapter Name"}
                              <Required />
                            </Label>
                            <div className="form-control-wrap">
                              <input
                                placeholder={"Enter chapter name"}
                                type="text"
                                id="chapter_name"
                                {...register("chapter_name", {
                                  required: {
                                    value: true,
                                    message: "chapter name is required",
                                  },
                                
                                     pattern: {
                                    value:/^(?=.*[A-Za-z0-9\u0900-\u097F])[A-Za-z0-9\u0900-\u097F\s()]+$/,
                                    message: "Only letters, numbers, Hindi text and () are allowed eg: Chapter 1 वास्तविक संख्याएँ (Real Numbers) or वास्तविक संख्याएँ (Real Numbers)",
                                  },
                                
                                  minLength: {
                                    value: 3,
                                    message: "chapter name must be at least 2 characters long",
                                  },
                                  maxLength: {
                                    value: 50,
                                    message: "chapter name cannot exceed 50 characters",
                                  },
                                })}
                                className="form-control"
                                value={watch("chapter_name")}
                                onChange={(e) => {
                                  // let value = e.target.value.replace(/[^A-Za-z\s]/g, ""); // Remove invalid characters
                                  // value = value.replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
                                  setValue("chapter_name", e.target.value);
                                  trigger("chapter_name"); // Trigger validation
                                }}
                                // onInput={(e) => {
                                //   e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, "");
                                // }}
                              />
                              {errors.chapter_name && <span className="invalid">{errors?.chapter_name?.message}</span>}
                            </div>
                          </div>
                        </Col>{" "}
                        {/* Chapter Order */}
                        {/* <Col md="2" sm="3" xxl="1">
                      <div className="form-group">
                        <Label className="form-label" htmlFor="order">
                          {"Order"}
                          <Required />
                        </Label>
                        <div className="form-control-wrap">
                          <input
                            placeholder={"Enter order"}
                            type="text"
                            id="order"
                            {...register("order", {
                              required: "Order is required",
                              pattern: {
                                value: /^[1-9][0-9]{0,2}$/,
                                message: "Enter a Order greater than 0 and up to 100",
                              },
                              minLength: {
                                value: 1,
                                message: "Order must be at least 1 character long",
                              },
                              validate: (value) => (value >= 1 && value <= 100) || "Order must be between 1 and 100",
                            })}
                            className="form-control"
                            onChange={(e) => {
                              e.target.value = e.target.value.replace(/[^0-9]/g, ""); // Remove non-numeric characters
                              setValue("order", e.target.value);
                              trigger("order"); // Trigger validation
                            }}
                            value={watch("order")}
                          />
                          {errors.order && <span className="invalid">{errors?.order?.message}</span>}
                        </div>
                      </div>
                    </Col>{" "} */}
                        {/* Status */}
                        <Col md={`2`}>
                          <Status
                            setValue={setValue}
                            trigger={trigger}
                            register={register}
                            watch={watch}
                            errors={errors}
                          />
                        </Col>
                      </Row>
                      <Col md="2" className={``}>
                        <MyButton isLoading={isLoading} mode={mode} />
                      </Col>
                    </Form>
                  </PreviewAltCard>
                )}
                <MyDataTable data={data} columns={column} title={"Subject"} isLoading={isLoading} />
              </Row>
            </Block>
          </>
        )}
      </Content>
      {/* Confirmation Modal */}
      <ConfirmModal
        isOpen={showModal}
        toggle={() => setShowModal(!showModal)}
        onConfirm={confirmStatusChange}
        status={selectedRow?.status}
      />
    </>
  );
};

export default Chapter;
